import { Group } from 'three';
import {
    buildKinteki,
    buildEnteki,
    buildMakiwara,
    KintekiOrdermadeArrowModel,
    EntekiOrdermadeArrowModel,
    MakiwaraOrdermadeArrowModel,
} from '@app/react/3d';
import { ASSETS_PATH, ORDERMADE_ARROW_NAME } from '@app/react/const/variables';
import { fbxLoader } from '@app/react/common/fbxLoader';

export const fetchKintekiModel = async (
    enableRestore: boolean,
): Promise<KintekiOrdermadeArrowModel> => {
    const object = await fbxLoader.loadAsync(
        `${ASSETS_PATH}/models/kinteki.fbx`,
    ) as Group;
    console.log('[3d] load kinteki model:', object);
    console.log('[3d] enableResore', enableRestore);

    object.name = ORDERMADE_ARROW_NAME;
    object.position.set(0, 0, 0);
    object.rotation.set(0, 0, 0);

    const model = buildKinteki(object, enableRestore);
    return model;
};

export const fetchEntekiModel = async (
    enableRestore: boolean,
): Promise<EntekiOrdermadeArrowModel> => {
    const object: Group = await fbxLoader.loadAsync(
        `${ASSETS_PATH}/models/enteki.fbx`,
    );
    console.log('[3d] load enteki model:', object);
    console.log('[3d] enableResore', enableRestore);

    object.name = ORDERMADE_ARROW_NAME;

    const model = buildEnteki(object, enableRestore);
    return model;
};

export const fetchMakiwaraModel = async (
    enableRestore: boolean,
): Promise<MakiwaraOrdermadeArrowModel> => {
    const object: Group = await fbxLoader.loadAsync(
        `${ASSETS_PATH}/models/makiwara.fbx`,
    );
    console.log('[3d] load makiwara model:', object);
    console.log('[3d] enableResore', enableRestore);

    object.name = ORDERMADE_ARROW_NAME;

    const model = buildMakiwara(object, enableRestore);
    return model;
};
